var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.5 5C9.74167 5 7.5 7.24167 7.5 10C7.5 12.7583 9.74167 15 12.5 15C15.2583 15 17.5 12.7583 17.5 10C17.5 7.24167 15.2583 5 12.5 5Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 3.33334C8.81634 3.33334 5.83301 6.31668 5.83301 10C5.83301 13.6833 8.81634 16.6667 12.4997 16.6667C16.183 16.6667 19.1663 13.6833 19.1663 10C19.1663 6.31668 16.183 3.33334 12.4997 3.33334ZM12.4997 15C9.74134 15 7.49967 12.7583 7.49967 10C7.49967 7.24168 9.74134 5.00001 12.4997 5.00001C15.258 5.00001 17.4997 7.24168 17.4997 10C17.4997 12.7583 15.258 15 12.4997 15ZM2.49967 10C2.49967 7.82501 3.89134 5.97501 5.83301 5.29168V3.55001C2.95801 4.29168 0.833008 6.89168 0.833008 10C0.833008 13.1083 2.95801 15.7083 5.83301 16.45V14.7083C3.89134 14.025 2.49967 12.175 2.49967 10Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSession);
export default __webpack_public_path__ + "static/media/session.7e1445209e5ee0623d70e62b98135046.svg";
export { ForwardRef as ReactComponent };